<script>
    import { maxInputLength } from "../../../../../../api/hooks/config-client"
    import { login } from "../../../../functionTools/login"
    import { inquiry } from "../../../../functionTools/offerAssistant"
    import FormInputText from "../../../widgets/Form/FormInputText.svelte"
    import { _ } from "svelte-i18n"
</script>

{#if $login?.account?.email}
    <div class="col-md-6">
        <label for="inquiry_email">{$_("inquiry.email")}</label><br />
        <small>{$login.account.email}</small>
    </div>
    <div class="col-md-6">
        <label for="inquiry_phone">{$_("inquiry.phone")}</label><br />
        <small>{$login.account.phone || "-"}</small>
    </div>
{:else}
    <div class="col-md-6">
        <FormInputText
            name="email"
            label={$_("inquiry.email")}
            bind:value={$inquiry.contact.email}
            type="email"
            required
            maxlength={maxInputLength.email}
        />
    </div>
    <div class="col-md-6">
        <FormInputText
            name="phone"
            label={$_("inquiry.phone")}
            tooltip={$_("inquiry.phone-tooltip")}
            bind:value={$inquiry.contact.phone}
            type="tel"
            required
            maxlength={maxInputLength.phone}
        />
    </div>
{/if}
